// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprSinLogoP2 extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.sin_logo.p_2";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprSinLogoP2 {
        this.VALUES ??= this.completar({
            "valor": {
                "es": "La publicidad digital personalizada, basada en la información recogida mediante cookies o tecnologías similares, nos permite financiar nuestra actividad para seguir ofreciéndote contenido con altos estándares de calidad sin coste."
            },
            "defecto": "La publicidad digital personalizada, basada en la información recogida mediante cookies o tecnologías similares, nos permite financiar nuestra actividad para seguir ofreciéndote contenido con altos estándares de calidad sin coste."
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
